export default __webpack_public_path__ + "static/KeywordResearch_01_03-16953efe018d96ccddf172c9b00d0abe.png";